import { getAdminUsers } from '@/services/admin-user';
import { useQuery } from '@tanstack/react-query';

// Public projection only — the API never returns status, PII, or pay fields.
export type AdminUser = {
  admin_user_id: string;
  first_name: string;
  last_name?: string;
  profile_picture?: string | null;
  bio?: string | null;
  role: 'SUPER_ADMIN' | 'ADMIN' | 'INSTRUCTOR';
  class_ids?: string[];
};

export default function useAdminUsers({
  role,
  enabled = true,
}: {
  role?: AdminUser['role'];
  enabled?: boolean;
} = {}) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['adminUsers', role],
    queryFn: () => getAdminUsers({ role }),
    enabled,
    // The pack and membership pages wait on this and their instructors
    // section observes it, so the same loop as useClassGroups.
    retryOnMount: false,
  });

  return {
    data,
    isLoading,
    error,
    refetch,
  };
}
